// Free-gift promotion ("spend €X, get a free item") — shared by banner sticker, basket
// nudge, checkout summary and admin preview. Mirrors backend services/gift_promo.py.
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const GIFT_DEFAULTS = {
  threshold: 100,
  title: 'FREE FOOD',
  subtitle: 'on orders €{amount}+',
  giftName: 'FREE GARNELEN4YOU shrimp food',
  stripText: '🎁 Spend €{amount} or more and get {gift} with your order!',
};

const fmtAmount = (n) => (Number.isInteger(n) ? String(n) : n.toFixed(2));

export const resolveMediaUrl = (url) => (url && url.startsWith('/') ? `${BACKEND}${url}` : url || '');

export const giftPromoActive = (settings) =>
  !!settings?.gift_promo_enabled && (parseFloat(settings.gift_promo_threshold) || 0) > 0;

// Everything the UI needs: texts with placeholders filled, progress toward the threshold.
export const giftPromoStatus = (settings, totalPrice = 0) => {
  if (!giftPromoActive(settings)) return null;
  const threshold = parseFloat(settings.gift_promo_threshold) || GIFT_DEFAULTS.threshold;
  const giftName = (settings.gift_promo_gift_name || '').trim() || GIFT_DEFAULTS.giftName;
  const fill = (text, fallback) =>
    ((text || '').trim() || fallback).replace(/\{amount\}/g, fmtAmount(threshold)).replace(/\{gift\}/g, giftName);
  const gap = Math.max(0, threshold - totalPrice);
  return {
    threshold,
    giftName,
    title: fill(settings.gift_promo_title, GIFT_DEFAULTS.title),
    subtitle: fill(settings.gift_promo_subtitle, GIFT_DEFAULTS.subtitle),
    stripText: fill(settings.gift_promo_strip_text, GIFT_DEFAULTS.stripText),
    image: resolveMediaUrl(settings.gift_promo_image),
    gap,
    unlocked: gap <= 0,
    progress: Math.min(100, Math.max(4, (totalPrice / threshold) * 100)),
  };
};
